import get from 'lodash/get';
import moment from 'moment';

import PersonAvatar from '~/components/PersonAvatar';
import { TableCell, TableRow } from '~/components/Table';

import styles from './styles';

class Pageview extends React.Component {
  formatTimestamp = (time) => moment(time).fromNow();

  render() {
    const { event, classes } = this.props;
    const eventSearch = get(event, 'properties.search', '');
    const eventUrl = get(event, 'properties.url', '#').replace(eventSearch, '');

    return (
      <TableRow key={event.id} className={classes.root}>
        <TableCell
          innerClassName={classes.eventPersonName}
          ellipsis
          title={event.person}>
          <PersonAvatar
            className={classes.personAvatar}
            src={get(event, 'person.avatar')}
            size={24}
          />
          {get(event, 'person.name') ||
            get(event, 'person.email') ||
            'Anonymous'}
        </TableCell>

        <TableCell ellipsis slim title={eventUrl}>
          <a href={eventUrl}>{get(event, 'properties.path', '--')}</a>
        </TableCell>

        <TableCell ellipsis slim title={event.timestamp}>
          {this.formatTimestamp(event.timestamp)}
        </TableCell>
      </TableRow>
    );
  }
}

Pageview.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
};

export default withStyles(styles)(Pageview);
